module.exports = __webpack_public_path__ + "img/gms_2.b5738635.png";